var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',{attrs:{"trim":"","type":"text","value":_vm.value,"state":_vm.state || _vm.isValidEmailAddress,"placeholder":_vm.placeholder,"autocomplete":_vm.autocomplete},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }